import React from "react";

const aboutResponsiveStyles = `
  *, *::before, *::after { box-sizing: border-box; }

  @media (max-width: 768px) {
    .about-grid {
      grid-template-columns: 1fr !important;
      gap: 2rem !important;
    }

    .about-images {
      position: relative !important;
      width: 100% !important;
      height: 280px !important;
      min-height: 280px !important;
    }

    .about-img-main {
      width: 65% !important;
      height: 100% !important;
    }

    .about-img-accent {
      width: 45% !important;
      height: 60% !important;
    }

    .stats-row {
      grid-template-columns: 1fr 1fr !important;
      gap: 1rem !important;
    }
  }

  @media (max-width: 480px) {
    .about-images {
      height: 240px !important;
      min-height: 240px !important;
    }

    .about-img-main {
      width: 60% !important;
    }

    .about-img-accent {
      width: 48% !important;
      height: 55% !important;
    }

    .about-features {
      flex-direction: column !important;
      gap: 0.75rem !important;
    }

    .stats-row {
      grid-template-columns: 1fr 1fr !important;
    }
  }
`;

function About() {
  return (
    <section id="about" style={{ background: "var(--warm-white)" }}>
      <style>{aboutResponsiveStyles}</style>
      <div className="about-grid">
        <div className="about-images reveal-left">
          <img
            src="https://images.unsplash.com/photo-1552693673-1bf958298935?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
            alt="Spa treatment"
            className="about-img-main"
            style={{
              width: "300px",
              height: "400px",
              objectFit: "cover",
              position: "absolute",
              top: 0,
              left: 0,
            }}
          />
          <img
            src="https://images.unsplash.com/photo-1506126613408-eca07ce68773?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
            alt="Relaxing spa"
            className="about-img-accent"
            style={{
              width: "220px",
              height: "300px",
              objectFit: "cover",
              position: "absolute",
              bottom: 0,
              right: 0,
              border: "6px solid var(--cream)",
            }}
          />
          <div className="about-badge">
            <div className="about-badge-num">10+</div>
            <div className="about-badge-text">
              Years of
              <br />
              Excellence
            </div>
          </div>
        </div>
        <div className="reveal-right" style={{ transitionDelay: ".15s" }}>
          <div className="section-label">About Us</div>
          <h2 className="section-title" style={{ marginBottom: "24px" }}>
            Discover The Ultimate
            <br />
            <em>Spa Experience</em>
          </h2>
          <p
            style={{
              color: "var(--text-light)",
              lineHeight: 1.9,
              fontSize: ".95rem",
              fontWeight: 300,
              marginBottom: "16px",
            }}
          >
            Step into a haven of peace and indulgence, where every detail is
            crafted for your comfort and well-being. Reconnect with yourself
            through our luxurious treatments and calming atmosphere.
          </p>
          <p
            style={{
              color: "var(--text-light)",
              lineHeight: 1.9,
              fontSize: ".95rem",
              fontWeight: 300,
              marginBottom: "28px",
            }}
          >
            Our expert therapists blend ancient healing wisdom with modern
            techniques to offer you an experience unlike any other — a sanctuary
            where stress melts away.
          </p>
          <div className="about-features">
            {[
              {
                icon: "🌿",
                title: "Natural Products",
                desc: "Pure organic blends",
              },
              {
                icon: "👐",
                title: "Expert Therapists",
                desc: "Certified specialists",
              },
              {
                icon: "🕊️",
                title: "Peaceful Ambiance",
                desc: "Total tranquility",
              },
            ].map((f) => (
              <div className="feature-item" key={f.title}>
                <div className="feature-icon">{f.icon}</div>
                <div>
                  <div className="feature-title">{f.title}</div>
                  <div className="feature-desc">{f.desc}</div>
                </div>
              </div>
            ))}
          </div>
          <div className="stats-row">
            {[
              ["10+", "Years Experience"],
              ["100%", "Natural Products"],
              ["5K+", "Happy Clients"],
              ["15+", "Specialists"],
            ].map(([n, l]) => (
              <div className="stat-item" key={l}>
                <div className="stat-num">{n}</div>
                <div className="stat-label">{l}</div>
              </div>
            ))}
          </div>
          <button className="btn-primary" style={{ marginTop: "8px" }}>
            Discover More
          </button>
        </div>
      </div>
    </section>
  );
}

export default About;
